import React, { useState, useEffect } from 'react';
import { Modal, withStyles } from '@material-ui/core';
import { Button } from '../../../components/ui/Buttons';
import { TextField } from '../../../components/TextField';
import { findResumoAvaliacaoById } from '../../../services/AiService';


const MotivoDislikeModal = ({ classes, open, onClose, resumoAvaliacaoId, onConfirm }) => {
  const [motivo, setMotivo] = useState('');
  const [tipo, setTipo] = useState('');

  const buscarAvaliacao = async () => {
    if (resumoAvaliacaoId) {
      try {
        const response = await findResumoAvaliacaoById(resumoAvaliacaoId);
        const avaliacao = response.data.data.findResumoAvaliacaoById;
        setMotivo(avaliacao?.motivo || '');
        setTipo(avaliacao?.tipo);
      } catch (error) {
        console.error('Erro ao buscar avaliação:', error);
      }
    }
  };

  useEffect(() => {
    buscarAvaliacao();
  }, [open, resumoAvaliacaoId]);

  const tipoFormatado = tipo === 'CRONOLOGICO' ? 'cronológico' : 'unificado';

  return (
    <Modal open={open} onClose={() => onClose(null)}>
      <div className={classes.motivoModalContent}>
        <h3>Ajude-nos a melhorar nosso resumo {tipoFormatado}</h3>
        <p>Como podemos melhorar o resumo {tipoFormatado}?</p>
        <TextField
          id="prt-mdl-inp-mot"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          multiline
          rows={8}
          variant="outlined"
          fullWidth
          margin="normal"
        />
        <div className={classes.motivoModalActions}>
          <Button id="prt-mdl-btn-cnc" bgColor="#707C97" onClick={onClose} className={classes.cancelButton}>
            Cancelar
          </Button>
          <Button id="prt-mdl-btn-cnf" onClick={() => onConfirm(motivo, tipo)} className={classes.confirmButton}>
            Confirmar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const styles = {
  motivoModalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '24px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    outline: 'none',
    width: '400px',
    maxWidth: '90vw'
  },
  motivoModalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '20px'
  },
  cancelButton: {
    padding: '8px 16px',
    border: '1px solid #ccc',
    backgroundColor: 'white',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  confirmButton: {
    padding: '8px 16px',
    border: 'none',
    backgroundColor: '#219A97',
    color: 'white',
    borderRadius: '4px',
    cursor: 'pointer'
  }
};

export default withStyles(styles)(MotivoDislikeModal);